<style>
@import '../custom/css/cadastro.css';
</style>

<template>
  <div class="cadastro">
    <div class="container">
      <!-- Breadcrumb -->
      <div class="row p-25">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link
                  class="text-uppercase"
                  class-active="active"
                  :to="{ name: 'home' }"
                  >Ínicio</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link
                  class="text-uppercase"
                  class-active="active"
                  :to="{ name: 'area-restrita' }"
                  >Área Restrita</router-link
                >
              </li>
              <li
                aria-current="page"
                class="breadcrumb-item active text-uppercase"
              >
                Cadastro
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <h1 class="h1-after-center text-uppercase fwb mb-4" id="inicio">
            Dados Cadastrais
          </h1>
          <div class="box-desc text-center">
            <p class="roboto-n max-w-500 m-0-auto p-b-3em">
              Preencha seus dados cadastrais abaixo.
            </p>
          </div>
        </div>
        <div class="col-12">
          <div>
            <ShopkeeperRegister
              :cities="cidades"
              :states="estados"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Termos e Condições -->
    <TermsAndConditions />
    <!-- Política de Privacidade -->
    <PrivacyPolicy />

    <!-- Contrato Lojista Plano 1 -->
    <ShopkeeperContractPlan1 v-if="tipoUsuario === UserTypes.SHOPKEEPER" />
    <!-- Contrato Lojista Plano 2 -->
    <ShopkeeperContractPlan2 v-if="tipoUsuario === UserTypes.SHOPKEEPER" />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex';
import TermsAndConditions from '../components/TermsAndConditions.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import ShopkeeperContractPlan1 from '../components/ShopkeeperContractPlan1.vue';
import ShopkeeperContractPlan2 from '../components/ShopkeeperContractPlan2.vue';
import ShopkeeperRegister from './lojista/Register.vue';
import makeToast from '../mixins/makeToast';
import UserTypes from "../enums/UserTypes";
import scrollToElement from '../mixins/scrollToElement';

export default {
  name: "cadastro",
  mixins: [makeToast, scrollToElement],
  components: {
    TermsAndConditions,
    PrivacyPolicy,
    ShopkeeperContractPlan1,
    ShopkeeperContractPlan2,
    ShopkeeperRegister
  },
  data() {
    return {
      UserTypes,
      tipoUsuario: 3,
      afiliadoId: 0,
      partnerId: '',
      typePerson: '',
      Fields: {
        paymentPlan: '',
        cep: '',
        endereco: '',
        bairro: '',
        cidade_id: null,
      },
      ErrorMessages: {
        paymentPlan: null,
        address: null,
        cep: null,
        neighborhood: null,
        city: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      specialRegister: false,
      externo: false,
    };
  },
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification', 'getBaseUri']),
    ...mapGetters('general', ['getCities']),
    ...mapState([
      'tipoUsuarios',
      'estados',
      'cidades',
      'planos',
      'segmentos',
      'dadosUsuario',
    ]),
  },
  beforeCreate() {
    this.$store.dispatch('loadTipoUsuarios');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadPlanos');
    this.$store.dispatch('loadSegmentos');
  },
  created() {
    this.scrollToElement();
  },
  beforeMount() {
    if (this.$router.history.current.name === "cadastro") {

      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: 'area-restrita' });
      } else {
        this.$router.push({ name: 'cadastro', query: this.$route.params });
      }
    }
  },
  mounted() {
    this.getAllCities();
    this.scrollToElement();
  },
  methods: {
    ...mapActions('general', ['getAllCities']),
    ...mapActions('partner', ['validateInviteId']),
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === 'null' ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
